import { ToggleSwitch } from '@/components';
import { ColumnConfig } from '@/components/table/Table';
import { formatPhoneForDisplay } from '@/utils';
import { DriverApi } from '../models';
import { DriverStatus, DriverStatusLabels } from '../enums';
import {
  DEFAULT_STATUS_CHIP_CLASS,
  DRIVER_STATUS_CHIP_CLASSES,
} from './statusChip';

type DriversTableColumnHandlers = {
  onToggleRequest: (driverId: string, value: boolean) => void;
  canManageActive: boolean;
};

export const getDriversTableColumns = ({
  onToggleRequest,
  canManageActive,
}: DriversTableColumnHandlers): ColumnConfig[] => {
  const baseColumns: ColumnConfig[] = [
    {
      label: 'Nombre completo',
      field: 'fullName',
      render: (_value: unknown, rowData: DriverApi) => {
        const firstName = rowData.firstName || '';
        const lastName = rowData.lastName || '';
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || '______';
      },
    },
    {
      label: 'Teléfono laboral',
      field: 'workPhoneNumber',
      render: (value: string | null | undefined) => formatPhoneForDisplay(value),
    },
    {
      label: 'Email',
      field: 'email',
      render: (value: string) => value || '______',
    },
    {
      label: 'Operador logístico actual',
      field: 'currentOperator',
      render: (_value: unknown, rowData: DriverApi) => {
        return rowData.currentOperator?.name || 'Sin asignar';
      },
    },
    {
      label: 'Estado',
      field: 'status',
      sortable: true,
      render: (value: string) => {
        const label = DriverStatusLabels[value as DriverStatus] || value;
        const chipClass = DRIVER_STATUS_CHIP_CLASSES[value] ||
        DEFAULT_STATUS_CHIP_CLASS;
        return (
          <span
            className={`px-3 py-1 rounded-md text-sm font-semibold ${chipClass}`}
          >
            {label}
          </span>
        );
      },
    },
  ];

  if (canManageActive) {
    baseColumns.push({
      label: 'Activo',
      field: 'active',
      render: (_value: unknown, rowData: DriverApi) => {
        const fullName =
          `${rowData.firstName || ''} ${rowData.lastName || ''}`.trim();
        const checked = rowData.status === DriverStatus.ACTIVE;
        const ariaLabel = fullName
          ? `Estado de ${fullName}`
          : 'Estado del conductor';
        return (
          <ToggleSwitch
            checked={checked}
            onChange={(value) => onToggleRequest(rowData.id, value)}
            ariaLabel={ariaLabel}
          />
        );
      },
    });
  }

  return baseColumns;
};
